
import { Component, Vue } from 'vue-property-decorator'
import ReviewProblemList from '@/components/templates/ReviewProblemList.vue'
import { ReviewProblem } from '@/models/ReviewProblem'
import { CurriculumUnit } from '@/models/CurriculumUnit'
import { ApiNotFoundAppError } from '@/models/AppErrorClasses'
import { UserReviewProblemsApi } from '@/api/methods/UserReviewProblemsApi'
import { CurriculumUnitsApi } from '@/api/methods/CurriculumUnitsApi'
import { FixedExercisesApi } from '@/api/methods/FixedExercisesApi'
import { ApiResponseFixedExerciseProblem } from '@/api/responses/fixedExercises'

/**
 * 単元別復習問題選択
 */
@Component({
  components: {
    ReviewProblemList,
  },
})
export default class SelectReviewProblem extends Vue {
  /** 読み込み完了フラグ */
  private isLoaded = false

  /** 復習問題一覧 */
  private problemList: ReviewProblem[] = []

  /** 単元情報 */
  private curriculumUnit!: CurriculumUnit

  /**
   * 選択中の単元IDを取得して返す
   *
   * @returns 単元ID
   */
  private get curriculumUnitId(): number {
    return Number(this.$route.params.curriculumUnitId)
  }

  /**
   * 初期処理
   */
  private async mounted(): Promise<void> {
    this.$loading.start()
    // クッキーから学年と教科情報を取得
    const currentSubjectCode = await this.$appCookies.studentMenuState.subjectCode.get()
    const currentGradeCode = await this.$appCookies.studentMenuState.gradeCode.get()
    // 問題一覧を取得
    const problems = await UserReviewProblemsApi.listCurriculumUnitProblems(
      this.curriculumUnitId,
      currentSubjectCode,
      currentGradeCode
    )
    this.problemList = problems.map((problem) => {
      let history = null
      // unix秒をDate型に変換
      if (problem.historyUnixTime) {
        history = new Date(problem.historyUnixTime * 1000)
      }
      return {
        level: problem.level,
        problemCode: problem.problemCode,
        historyDate: history,
      }
    })
    // 単元情報を取得
    const responseCurriculumUnit = await CurriculumUnitsApi.getCurriculumUnit(this.curriculumUnitId)
    this.curriculumUnit = {
      id: responseCurriculumUnit.id,
      name: responseCurriculumUnit.name,
    }
    this.isLoaded = true
    this.$loading.complete()
  }

  /**
   * 問題押下時の処理
   *
   * @param level 学習レベル
   * @param code 問題コード
   */
  private async eventClickProblem(level: number, code: string): Promise<void> {
    // 固定問題情報と小問情報を取得
    const fixedExercise = await FixedExercisesApi.getActive(this.curriculumUnitId, level)

    // 小問情報を取得
    let problem!: ApiResponseFixedExerciseProblem
    try {
      problem = await FixedExercisesApi.getProblem(fixedExercise.id, code)
    } catch (error) {
      if (error instanceof ApiNotFoundAppError) {
        alert('この問題は現在演習できません。')
        this.$loading.complete()
        return
      }

      // 404エラー以外の場合は例外を投げ直し、共通処理に渡す
      throw error
    }

    this.$router.push({
      path: `/student/review/study/${fixedExercise.id}/${problem.id}`,
      query: this.$prevPage.generateQuery(),
    })
  }

  /**
   * 戻るボタン押下時の処理
   */
  private eventClickBackButton(): void {
    this.$router.push('/student/review')
  }
}
